import { useDaily } from '@daily-co/daily-react';
import { useEffect, useState } from 'react';

export default function useParticipantsArray() {
  const daily = useDaily();
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    if (!daily) return;
    const update = () => {
      const obj = daily.participants();
      setParticipants(Object.values(obj));
    };
    update();
    daily.on('participant-joined', update);
    daily.on('participant-left', update);
    daily.on('participant-updated', update);
    return () => {
      daily.off('participant-joined', update);
      daily.off('participant-left', update);
      daily.off('participant-updated', update);
    };
  }, [daily]);

  return participants;
}
